export default function LoadingPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <span className="text-secondary text-sm">Loading…</span>
    </div>
  );
}
